module.exports = __webpack_public_path__ + "static/media/look-around.0c5c27b0.png";